module.exports = __webpack_public_path__ + "static/bug-a3f5c9df771770f9f0d2bb7961001ec9.png";